import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { Row } from "reactstrap";
import {
  IToolbarContentConfig,
  IToolbarLanguageConfig,
} from "../../app/models/toolbar";
import { RootStoreContext } from "../../app/stores/rootStore";
import DownloadButtonsContainer from "../containers/DownloadButtonsContainer";
import NotesDropdownContainer from "../containers/NotesDropdownContainer";
import LanguageDropdown from "../dropdowns/LanguageDropdown";
import PageSelector from "../widgets/PageSelector";
import ZoomPortionButton from "../buttons/toolbar/ZoomPortionButton";

interface IParams {
  totalItems: number;
  languageSelectionConfig: IToolbarLanguageConfig | undefined;
  contentConfig: IToolbarContentConfig | undefined;
}

export const ToolbarFileTabPane: React.FC<IParams> = ({
  totalItems,
  languageSelectionConfig,
  contentConfig,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {
    toolbar,
    currentBrowsePageContent,
    currentGalleryPage,
    setGalleryPage,
    isNativeApp,
    currentGalleryFile
  } = rootStore.commonStore;

  const handleLanguageSelect = (goToPageIndex: number, languageId?: number) => {
    if (languageSelectionConfig)
      languageSelectionConfig
        .changeLanguage(languageId)
        .then((newTotalItems) => setGalleryPage(goToPageIndex, newTotalItems));
  };

  return (
    <>
      <div className="pb-1" style={{display: "flex", justifyContent: "space-between"}}>
        <div className="d-inline-flex">
          {/* DOWNLOAD BUTTONS */}
          {!isNativeApp && contentConfig && (
            <DownloadButtonsContainer
              contentId={contentConfig.contentId}
              downloadsConfig={contentConfig.downloadConfig}
            />
          )}

          {/* LANGUAGE DROPDOWN */}
          {languageSelectionConfig &&
            currentBrowsePageContent &&
            currentBrowsePageContent.languages &&
            currentBrowsePageContent.languages.availabeLanguages.length > 1 && (
              <LanguageDropdown
                languages={currentBrowsePageContent.languages.availabeLanguages}
                selectedLanguage={currentBrowsePageContent.languages.languageId}
                onLanguageSelect={(l) =>
                  handleLanguageSelect(currentGalleryPage, l)
                }
                direction="down"
                flagFontSize={30}
              />
            )}
        </div>

        <div >
          <PageSelector
            totalPages={totalItems}
            currentPage={currentGalleryPage + 1}
            onChangeCustom={(event) => {
              event.target.select();
              setGalleryPage(Number(event.target.value) - 1, totalItems);
            } } 
                    />
        </div>

        <div className="d-inline-flex " >
          <div className=" ml-auto"></div>   
          {( currentGalleryFile?.type!="video"   && !isNativeApp) && (<>
           <div className=" ml-auto">   </div>
           <ZoomPortionButton />
         
              </>)} 
         {contentConfig && contentConfig.enableNotes && (
            <NotesDropdownContainer noteButtons={toolbar!.noteButtons} />
          )}
        </div>
         
        {/* <div className="d-inline-flex "></div>
        <div className=" ml-auto"></div>
          {( currentGalleryFile?.type!="video" ) && (<>
            <Div xl={1} md={1} sm={1}>            
          <ZoomPortionButton />
        </Div>
          </>)} 
        <Div xl={1} md={1} sm={1}>
          {contentConfig && contentConfig.enableNotes && (
            <NotesDropdownContainer noteButtons={toolbar!.noteButtons} />
          )}
        </Div> */}
         
         {/* <div className="row justify-content-end">
         <div className=" ml-auto"></div>
         {( currentGalleryFile?.type!="video" ) && (<>
            <Div >            
          <ZoomPortionButton />
        </Div>
          </>)} 
        <Div>
          {contentConfig && contentConfig.enableNotes && (
            <NotesDropdownContainer noteButtons={toolbar!.noteButtons} />
          )}
        </Div>
         </div> */}
        
      </div>
    </>
  );
};

export default observer(ToolbarFileTabPane);
